/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import { Chart } from 'primereact/chart';
import { useTranslation } from 'react-i18next';
import { Schedule } from '@/components/Schedule/getBuque';
import style from './DonutChart.module.scss';

type DonuntChartProps = {
  type: 'carga' | 'descarga';
  data?: Schedule;
};

const Legend: FC<{ data: any }> = ({ data }) => (
  <div className={style.containerLegend}>
    {data.labels
      .filter((label: string) => !label.toLowerCase().includes('rest'))
      .map((label: string, index: number) => {
        const startAt = index * 2;
        const processed = data.datasets[0].data[startAt + 1];
        const total = data.datasets[0].data[startAt] + processed;
        const color = data.datasets[0].backgroundColor[startAt + 1];
        const colorWithOpacity = `${color}80`;
        const size = 40;
        const porcentaje = (processed * 100) / total;
        const smallSize = size * (porcentaje / 100) || size;

        return (
          <div key={label} className={style.legendItem}>
            <div
              style={{
                backgroundColor: colorWithOpacity,
                width: size,
                height: size,
              }}
              className={style.legendItemIcon}
            >
              <div
                style={{
                  width: smallSize,
                  height: smallSize,
                  backgroundColor: color,
                }}
                className={style.legendItemIconInner}
              />
            </div>

            <div className={style.legendItemText}>
              <b>{label}</b>
              <span className={style.legendItemTextProcessed}>
                <span>{`${processed}/${total}`}</span>
                <span>procesados</span>
              </span>
            </div>
          </div>
        );
      })}
  </div>
);

const DonutChart: FC<DonuntChartProps> = ({ type, data }) => {
  const { t } = useTranslation('privateStopovers');
  const donutData = {
    labels: [
      t('RestTransit'),
      t('Transhipment'),
      t('RestFull'),
      t('Full'),
      t('RestEmpty'),
      t('Empty'),
    ],
    datasets: [
      {
        data:
          type === 'carga'
            ? [
                (data?.totalTransitoCarga || 0) -
                  (data?.transitoProcesadaCarga || 0),
                data?.transitoProcesadaCarga,
                (data?.totalFullCarga || 0) - (data?.fullProcesadoCarga || 0),
                data?.fullProcesadoCarga,
                (data?.totalVacioCarga || 0) - (data?.vacioProcesadoCarga || 0),
                data?.vacioProcesadoCarga,
              ]
            : [
                (data?.totalTransitoDescarga || 0) -
                  (data?.transitoProcesadaDescarga || 0),
                data?.transitoProcesadaDescarga,
                (data?.totalFullDescarga || 0) -
                  (data?.fullProcesadoDescarga || 0),
                data?.fullProcesadoDescarga,
                (data?.totalVacioDescarga || 0) -
                  (data?.vacioProcesadoDescarga || 0),
                data?.vacioProcesadoDescarga,
              ],
        backgroundColor: [
          '#faae3080',
          '#faae30',
          '#619b7780',
          '#619b77',
          '#8b3b8380',
          '#8b3b83',
        ],
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    cutout: '75%',
  };

  return (
    <div className={style.container}>
      <Legend data={donutData} />
      <Chart
        type="doughnut"
        data={donutData}
        options={options}
        className={style.chart}
      />
    </div>
  );
};

export default DonutChart;
